function r(r){try{for(let n=r;n>0;n--)if(ApplePaySession?.supportsVersion(n))return n}catch(r){console.warn(r)}return null}export{r as resolveSupportedVersion};
//# sourceMappingURL=resolve-supported-version.js.map
